import { render, staticRenderFns } from "./add_mindset_page.vue?vue&type=template&id=5738fcaa&scoped=true"
import script from "./add_mindset_page.vue?vue&type=script&lang=js"
export * from "./add_mindset_page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5738fcaa",
  null
  
)

export default component.exports